import {ACTION_TYPES} from 'Utils/constants';

const setExplorerLoaded = data => ({
    type: ACTION_TYPES.EXPLORER.SET_EXPLORER_LOADED,
    data,
});

export default setExplorerLoaded;
